<template>
  <section id="commitments" class="card background-opacity text-white p-5">
    <!-- Encabezado -->
    <div class="text-center mb-5">
      <h1 class="orbitron-font text-title">Our Commitment to Excellence</h1>
      <p class="fs-5" style="max-width: 650px; margin: 0 auto">We build reliable, transparent technology designed for people. Every decision, every improvement and every line of code reflects these pillars.</p>
    </div>
    <!-- GRID -->
    <div class="row g-5">
      <!-- Transparencia -->
      <div class="col-md-4 text-center">
        <div class="mb-3">
          <i class="fs-1 fa-brands fa-signal-messenger"></i>
        </div>
        <h4 class="oswald-font text-subtitle mb-2">Transparency</h4>
        <p>We operate <span class="text-neon oswald-font">with clear and measurable processes</span>. We communicate openly about how we manage data, decisions, and results. Transparency is the foundation of our relationship with users and customers.</p>
        <a href="/about" class="link-custom main anim-down fw-semibold small">Learn More</a>
      </div>
      <!-- Seguridad -->
      <div class="col-md-4 text-center">
        <div class="mb-3">
          <i class="fs-1 fa-solid fa-shield-halved"></i>
        </div>
        <h4 class="oswald-font text-subtitle mb-2">Security</h4>
        <p>We apply <span class="text-neon oswald-font">enterprise-grade standards</span>: encryption, strict access controls, redundancy, continuous monitoring, and regulatory compliance. Our focus is on protecting data and ensuring total continuity. We handle our end users data with the utmost care and protection, <span class="text-neon oswald-font">fully aware of how sensitive personal health information can be</span>.</p>
        <a href="/about" class="link-custom main anim-down fw-semibold small">Learn More</a>
      </div>
      <!-- Experiencia -->
      <div class="col-md-4 text-center">
        <div class="mb-3">
          <i class="fs-1 fa-solid fa-medal"></i>
        </div>
        <h4 class="oswald-font text-subtitle mb-2">Experience</h4>
        <p>We design <span class="text-neon oswald-font">intuitive and user-friendly interfaces</span>. We listen to our users, iterate quickly, and evolve without losing simplicity, keeping innovation at the core of development. We also understand the wide age range and diversity of the end users we serve, and we strive to ensure the experience remains <span class="text-neon oswald-font">comfortable and accessible for everyone</span>.</p>
        <a href="/about" class="link-custom main anim-down fw-semibold small">Learn More</a>
      </div>
    </div>
  </section>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin.js';

export default {
  mixins: [GlobalMixin],
  name: 'Commitments',
  data() {
    return {};
  },
};
</script>
